"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @babel/preset-env с опцией usage должен импортить полифиллы
// для работы реакта, но этого не происходит
// https://github.com/babel/babel/issues/7335
require("core-js/es/map");
require("core-js/es/set");
require("regenerator-runtime/runtime");
const pythia_libs_1 = require("@yandex-int/pythia-libs");
const lang_detect_1 = require("src/utils/lang-detect");
pythia_libs_1.i18n.setLang((0, lang_detect_1.langDetect)());
